var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 82,
    viewBox: "0 0 85 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1992:33154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1049 44.4258L20.9727 44.4554V44.4565L22.1049 44.4258Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9959 62.6192C22.077 57.7202 19.3059 51.8942 18.7501 45.2891L11.9018 46.0511L11.8103 46.0603L11.7177 46.0637C11.1825 46.0807 10.4791 46.1092 9.7849 46.1933C9.63622 46.2104 9.48754 46.232 9.33887 46.2536C10.2126 54.9494 14.0759 63.0833 20.302 69.2755C27.5002 76.4391 37.0727 80.3815 47.2536 80.3815C56.8535 80.3815 65.9102 76.8725 72.9483 70.4687L66.2441 63.801C61.0096 68.4224 54.3386 70.9544 47.273 70.9544C39.6002 70.9532 32.3997 67.9936 26.9959 62.6192Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9607 4.85547C36.7775 4.85547 27.2085 8.79899 20.0091 15.9581C19.1617 16.7998 18.3634 17.6756 17.6074 18.5821L24.355 25.2942C25.0858 24.3604 25.8555 23.4584 26.7041 22.6155C32.1079 17.2434 39.2947 14.2837 46.9435 14.2826C54.6164 14.2837 61.8169 17.2434 67.2218 22.6155C72.4404 27.808 75.391 34.6702 75.5797 42.0101C78.7145 41.4982 81.8584 40.9966 85.0012 40.4962C84.45 31.2214 80.5409 22.5496 73.9146 15.9581C66.7152 8.79899 57.145 4.85547 46.9653 4.85547H46.9607Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6531 11.668L6.71094 38.192L33.3103 34.2008L24.3554 25.2957L17.6078 18.5836L10.6531 11.668Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2438 63.8027L72.948 70.4704L79.8134 77.2984L83.8254 50.8438L57.1562 54.7645L66.2438 63.8027Z",
    fill: "#DEE2E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1992:33154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 82,
    fill: "white"
  })))));
}

export default SvgResetIcon;